module.exports = __webpack_public_path__ + "media/images/team/JorgeOsmaLopez-3f94f2b402b5bf81f972e9cab60e4750.png";